import React, { useState } from 'react';
import { OnboardingDraft } from './types';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { Eye, EyeSlash, FacebookLogo, GoogleLogo } from '@phosphor-icons/react';
interface StepAccountProps {
  data: Partial<OnboardingDraft>;
  updateData: (data: Partial<OnboardingDraft>) => void;
  onSubmit: () => void;
}
export function StepAccount({
  data,
  updateData,
  onSubmit
}: StepAccountProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState(data.account?.email || '');
  const [password, setPassword] = useState(data.account?.password || '');
  const handleSocial = (method: 'facebook' | 'google') => {
    updateData({
      account: {
        method
      }
    });
    onSubmit();
  };
  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password) {
      updateData({
        account: {
          method: 'email',
          email,
          password
        }
      });
      onSubmit();
    }
  };
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-md mx-auto" data-id="element-1505">
      <div className="text-center" data-id="element-1506">
        <h2 className="text-2xl font-bold text-light-1" data-id="element-1507">
          Salvează-ți Profilul
        </h2>
        <p className="text-light-3 mt-2" data-id="element-1508">
          Creează cont ca să trimitem ofertele direct la tine.
        </p>
      </div>

      <div className="space-y-4" data-id="element-1509">
        <Button onClick={() => handleSocial('facebook')} className="w-full h-12 bg-[#1877F2]/10 hover:bg-[#1877F2]/20 text-light-1 border border-[#1877F2]/30" data-id="element-1510">
          <FacebookLogo weight="fill" className="w-5 h-5 mr-3 text-[#1877F2]" data-id="element-1511" />
          Continuă cu Facebook
        </Button>

        <Button onClick={() => handleSocial('google')} className="w-full h-12 bg-dark-2 hover:bg-dark-3 text-light-1 border border-dark-3" data-id="element-1512">
          <GoogleLogo weight="bold" className="w-5 h-5 mr-3" data-id="element-1513" />
          Continuă cu Google
        </Button>

        <div className="relative py-4" data-id="element-1514">
          <div className="absolute inset-0 flex items-center" data-id="element-1515">
            <span className="w-full border-t border-dark-3" data-id="element-1516" />
          </div>
          <div className="relative flex justify-center text-xs uppercase" data-id="element-1517">
            <span className="bg-dark-1 px-2 text-light-3" data-id="element-1518">sau</span>
          </div>
        </div>

        <form onSubmit={handleEmailSubmit} className="space-y-4" data-id="element-1519">
          <Input type="email" placeholder="Adresa de email" value={email} onChange={e => setEmail(e.target.value)} className="h-12 bg-dark-2 border-dark-3" required data-id="element-1520" />
          <div className="relative" data-id="element-1521">
            <Input type={showPassword ? 'text' : 'password'} placeholder="Parola" value={password} onChange={e => setPassword(e.target.value)} className="h-12 bg-dark-2 border-dark-3 pr-12" required data-id="element-1522" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-light-3 hover:text-light-1 p-1" data-id="element-1523">
              {showPassword ? <EyeSlash className="w-5 h-5" data-id="element-1524" /> : <Eye className="w-5 h-5" data-id="element-1525" />}
            </button>
          </div>

          <Button type="submit" className="w-full h-12 bg-lime-1 text-dark-1 hover:bg-lime-2 font-semibold text-base mt-2" data-id="element-1526">
            Creează cont
          </Button>
        </form>
      </div>

      <p className="text-xs text-light-3 text-center leading-relaxed" data-id="element-1527">
        Utilizarea platformei Izio este guvernată de{' '}
        <a href="/termeni" className="text-light-2 underline hover:text-lime-1" data-id="element-1528">
          Termenii și Condițiile
        </a>{' '}
        și{' '}
        <a href="/confidentialitate" className="text-light-2 underline hover:text-lime-1" data-id="element-1529">
          Politica de Confidențialitate
        </a>
        . Prin continuare, confirmi că ești de acord cu toți Termenii aplicabili
        și că ai luat la cunoștință Politica de Confidențialitate. De asemenea,
        ești de acord să primești e-mailuri de la noi, la care te poți dezabona
        oricând.
      </p>
    </div>;
}